
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

export default {
  name: 'ScoringMethodologyCategoryContent',
  components: { VueSlickCarousel },

  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      settings: {
        autoplay: false,

        arrows: true,
        dots: true,
        infinite: false,
        initialSlide: 0,
        slidesToShow: 3,
        slidesToScroll: 1,
        swipeToSlide: true,
        // variableWidth: true,
        adaptiveHeight: true,
        responsive: [],
      },
      responsiveSettings: [
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            slidesToShow: 1,
          },
        },
      ],
      areResonsiveSettingsApplied: false,

      activeItemId: this.data[0]?.id,
      carouselKey: 0,
    };
  },

  computed: {
    ScoringMethodologyCards() {
      return this.data.find((item) => item.id === this.activeItemId)?.MethodologyCards;
    },
  },

  watch: {
    ScoringMethodologyCards() {
      // this.adjustSlidesToShow();
      this.forceRerender();
    },
  },

  // workaround solution taken from https://github.com/gs-shop/vue-slick-carousel/issues/94
  // due to hydration issue when declaring responsive setting directly
  methods: {
    initHandler() {
      if (this.areResonsiveSettingsApplied === false) {
        this.applyResponsiveSettings();
        // this.adjustSlidesToShow();
      }
    },
    applyResponsiveSettings() {
      this.settings.responsive = this.responsiveSettings;
      this.areResonsiveSettingsApplied = true;
    },
    // adjustSlidesToShow() {
    //   if (this.ScoringMethodologyCards.length < 3) {
    //     this.settings.slidesToShow = this.ScoringMethodologyCards.length;
    //   }
    // },
    toggleActiveItem(value) {
      this.activeItemId = value;
    },
    forceRerender() {
      this.carouselKey += 1;
    },
  },
};
